import { useAirline } from "../context/AirlineContext";
import { ServicesClusters } from "../shared/AirlineSlideRenderers";

const SlideRBAServices = () => {
  const { airline } = useAirline();
  const brand = airline.brandColor || "#FFCD00";
  return <ServicesClusters airline={airline} brand={brand} />;
};

export default SlideRBAServices;
